module.exports = __webpack_public_path__ + "img/Examination.323edae6.svg";